var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"bps-toggle-button-container"},[_c('button',{staticClass:"bps-toggle-button",attrs:{"toggled":_vm.value},on:{"click":_vm.toggle}},[_c('span',{staticClass:"thumb"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }